import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './slices/apiSlice';
import authSliceReducer from './slices/authSlice';
import orderSliceReducer from './slices/orderSlice';
import customerSliceReducer from './slices/customerSlice';
import configSliceReducer from './slices/configSlice';
const store = configureStore({
	reducer: {
		[apiSlice.reducerPath]: apiSlice.reducer,
		order: orderSliceReducer,
		auth: authSliceReducer,
		customer: customerSliceReducer,
		config: configSliceReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			// RTK Query 缓存体积较大时，开发态序列化检查易超过默认 32ms 阈值；生产构建默认关闭该检查。
			serializableCheck: {
				warnAfter: 128,
				ignoredPaths: [`${apiSlice.reducerPath}.queries`, `${apiSlice.reducerPath}.mutations`],
			},
			immutableCheck: { warnAfter: 128 },
		}).concat(apiSlice.middleware),
	devTools: process.env.NODE_ENV === 'production' ? false : true,
});

export default store;
